<template lang="pug">
.wrapper-documentation(:class="'wrapper-documentation-'+context")
  include DashboardContacts.pug
</template>

<script type="text/javascript">
import Api from "@/components/services/Api";
import { mapState } from 'vuex';

export default {
  name: "DashboardContacts",
  components: {
  },
  computed: mapState([
    "token", "context",
  ]),
  data() {
    return {
      name: "",
      user: null,
      contacts: [],
    }
  },
  async created() {
    const listResponse = await Api.listContacts(this.$store.state.token)
    const data = listResponse.data
    this.contacts = data.items
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "Dashboard";
@import "DashboardResources";
@import "DashboardContacts";
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardContacts.vue